<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pb-12 pt-6">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 max-w-5xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          ACREDITARME
        </h1>
        <h1 class="text-gray-800 mb-4 text-2xl text-center pt-2 pb-5">
          Por favor complete el formulario en su totalidad
        </h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="numeric" @blur="validarDni" placeholder="Documento / Pasaporte"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
            <br/>
            <small>&bull; La organización informa que es obligatorio presentar el DNI o Pasaporte consignados en este formulario al momento de acceder a CAPER SHOW</small>            
          </div>
        </div>

        <!-- Formulario -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" :readonly="soloLectura" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido"  :readonly="soloLectura " class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Email</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text" placeholder="Email" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Reingrese su email</label>
            <Field name="mailConfirmacion" v-slot="{ field, errors }" v-model="formData.mailConfirmacion">
              <InputText v-bind="field" type="text" placeholder="Reingrese su email" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mailConfirmacion" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Empresa / Institución</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Empresa / Institución" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" placeholder="Cargo" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3"> 
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Web Site (opcional)</label>
            <Field name="website" v-slot="{ field, errors }" v-model="formData.website">
              <InputText v-bind="field" type="text" placeholder="Web site" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="website" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Pais</label>
            <Field name="pais" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.pais">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el pais" :options="paises" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="pais" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3" v-if="formData.pais.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.provincia">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3" v-if="formData.pais.id != '+54'"> 
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text"  placeholder="Provincia / Estado" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provinciaEstado" /></span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ field, errors }" v-model="formData.localidad">
              <InputText v-bind="field" type="text"  placeholder="Ingrese la localidad" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="formData.pais !== null" v-model="formData.pais.id" class="w-full p-inputtext-sm p-3" disabled="true" />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoAreaCel" v-slot="{ field, errors }" v-model="formData.codigoAreaCel">
              <InputText v-bind="field" type="text" placeholder="Codigo de área" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoAreaCel" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" placeholder="Número de celular sin el 15 delante" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Instagram (opcional)</label>
            <Field name="instagram" v-slot="{ field, errors }" v-model="formData.instagram">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su instagram (Opcional)"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="instagram" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">LinkedIn (opcional)</label>
            <Field name="linkedin" v-slot="{ field, errors }" v-model="formData.linkedin">
              <InputText v-bind="field" type="text"  placeholder="Ingrese su LinkedIn (Opcional)" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="linkedin" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Canal de streaming (opcional)</label>
            <Field name="canalStreaming" v-slot="{ field, errors }" v-model="formData.canalStreaming">
              <InputText v-bind="field" type="text"  placeholder="Su canal de streaming (Opcional)" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="canalStreaming" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">¿Alguna vez participó en CAPER Show ?</label>
            <Field name="participo" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.participo">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="opcionesSiNo" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="participo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Seleccione el ítem que mejor describa la actividad principal de su Empresa/Organización</label>
            <Field name="actividadPrincipal" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.actividadPrincipal">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="actividades" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}"/>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="actividadPrincipal" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" v-show="formData.actividadPrincipal?.id === 'Otros'">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Especifique la actividad</label>
            <Field name="otraActividad" v-slot="{ field, errors }" v-model="formData.otraActividad">
              <InputText v-bind="field" type="text"  placeholder="Otra actividad" maxlength="50" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="otraActividad" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Indique en qué área se desempeña dentro de su Empresa / Organización </label>
            <Field name="areaDentroDeLaEmpresa" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.areaDentroDeLaEmpresa">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="areasEmpresa" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}"/>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="areaDentroDeLaEmpresa" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" v-show="formData.areaDentroDeLaEmpresa?.id === 'Otra'">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Especifique el área</label>
            <Field name="otraArea" v-slot="{ field, errors }" v-model="formData.otraArea">
              <InputText v-bind="field" type="text" placeholder="Otra área" maxlength="50" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="otraArea" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Indique cuál es su Cargo/Rol dentro de la Empresa u Organización</label>
            <Field name="rolCargo" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.rolCargo">
                <Dropdown :panelStyle="{ width: '50%' }" @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="rolesCargo" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" >
                  <template #option="slotProps">
                    <div class="flex flex-col align-items-center">
                      <div>{{ slotProps.option.descripcion }}</div>
                      <div class="text-xs text-wrap">{{ slotProps.option.detalle }}</div>
                    </div>
                  </template>                  
                </Dropdown>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rolCargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" v-show="formData.rolCargo?.id === 'Otros'">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Especifique el Cargo/Rol</label>
            <Field name="otroCargo" v-slot="{ field, errors }" v-model="formData.otroCargo">
              <InputText v-bind="field" type="text"  placeholder="Otro cargo" maxlength="50" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="otroCargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Especifique su rol en la compra</label>
            <Field name="rolCompra" v-slot="{ handleChange, handleBlur, value , errors}" v-model="formData.rolCompra">
                <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="rolesCompra" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}"/>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="rolCompra" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="pt-2 pb-2 px-2">
            <div class="flex items-center">
              <input type="checkbox" id="aggrement" v-model="formData.terminosCondiciones" class="text-primary focus:ring-0 rounded-sm cursor-pointer">
              <label for="aggrement" class="text-gray-600 ml-3 cursor-pointer">Ya leí y estoy de acuerdo con los términos y condiciones</label>
            </div>
          </div>
          <div>
            <div class="pb-2 text-justify text-xs max-h-96 px-2">
              <p>&bull; Dejo constancia que he leído, comprendido y aceptado todos los términos de la presente inscripción.<br/>
                  &bull; Asimismo, acepto que CAPER puede utilizar y/o divulgar la información y/o datos aquí consignados (a excepción de DNI / PASAPORTE), así como las imágenes y videos que se tomen en el marco del evento, con el fin de difundirlos entre las empresas Expositoras y/o Sponsors y/o Prensa, para su conocimiento y aplicación pertinente.<br/>
                  &bull; Por razones de seguridad, los Visitantes aceptan ser fotografiados / filmados en el acceso así como a presentar sus DNIs físicos al momento de retirar su credencial.<br/>
                <br/>
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-2 px-4 py-2 bg-transparent border-blue-950 hover:bg-black text-blue-950 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>
      </div>
          
    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import jsonSiNo from '@/data/sino.json';
import jsonPaises from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';

import jsonAreas from '@/data/areas.json';
import jsonRolesCompra from '@/data/roles.json';
import jsonActividades from '@/data/actividades.json';
import jsonRolesCargo from '@/data/rolCargo.json';

import HeaderSection from '@/components/HeaderSection.vue'
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, StringIdLabelEntity, OrigenAcreditado, IdLabelEntity } from 'qreventos-suite/services';
import { ORIGEN_ACREDITADO, VERIFICADO, UPDATE, SAVE } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';


interface SiNo extends StringIdLabelEntity { }
interface Pais extends StringIdLabelEntity { }
interface Provincia extends IdLabelEntity { }
interface ActividadPrincipal extends StringIdLabelEntity { }
interface AreaEmpresa extends StringIdLabelEntity { }
interface RolCargo extends StringIdLabelEntity { }
interface RolCompra extends StringIdLabelEntity { }

export default defineComponent({
  components: {
    InputText, Dropdown, HeaderSection,
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      isSubmitting: false,
      soloLectura: false,
      paises: [] as Pais[],
      provincias: [] as Provincia[],
      opcionesSiNo: [] as SiNo[],
      actividades: [] as ActividadPrincipal[],
      areasEmpresa: [] as AreaEmpresa[],
      rolesCargo: [] as RolCargo[],
      rolesCompra: [] as RolCompra[],
      acreditado: undefined as unknown as Acreditado,
      hash :'',
      formData: {
        nombre: '',
        apellido: '',
        dni:'',
        mail: '',
        mailConfirmacion: '',
        empresa:'',
        cargo:'',
        website:'',
        pais: {"id": "+54", "descripcion": "Argentina"} as Pais,
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        localidad : '',
        codigoAreaCel: '',
        telefonoCelular: '',
        instagram: '',
        linkedin: '',
        canalStreaming: '',
        participo: undefined as unknown as SiNo,
        actividadPrincipal : undefined as unknown as ActividadPrincipal,
        areaDentroDeLaEmpresa : undefined as unknown as AreaEmpresa,
        rolCargo : undefined as unknown as RolCargo,
        rolCompra : undefined as unknown as RolCompra,
        terminosCondiciones: false,
        otraActividad: '',
        otraArea: '',
        otroCargo: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre : yup.string().required('Ingrese su nombre').min(2, 'Al menos 2 letras'),
        apellido : yup.string().required('Ingrese su apellido').min(2, 'Al menos 2 letras'),
        dni: yup.string().required('Ingrese su número de documento o pasaporte').min(3, 'Al menos 5 números').matches(/^\d+$/, 'Solo se permiten números'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido'),
        mailConfirmacion: yup.string().required('Ingrese el correo').email('Correo inválido').oneOf([yup.ref('mail')], 'Los correos no coinciden'),
        empresa : yup.string().required('Ingrese su empresa').min(2, 'Al menos 2 letras'),
        cargo : yup.string().required('Ingrese su cargo').min(2, 'Al menos 2 letras'),
        pais: yup.mixed().required('Seleccione una opción'),
        provincia: yup.mixed().when('pais.id', (key, schema) => {
            return key.toString() === '+54'
              ? schema.required('Seleccione la provincia')
              : schema.notRequired();
        }),
        provinciaEstado: yup.string().when('pais.id', (key, schema) => {
            return key.toString() != '+54'
              ? schema.required('Ingrese la provincia / estado')
              : schema.notRequired();
        }),
        localidad : yup.string().required('Ingrese la localidad').min(2, 'Al menos 2 letras'),
        codigoAreaCel: yup.string().required('Código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        participo: yup.mixed().required('Seleccione una opción'),
        actividadPrincipal: yup.mixed().required('Seleccione una opción'),
        areaDentroDeLaEmpresa: yup.mixed().required('Seleccione una opción'),
        rolCargo: yup.mixed().required('Seleccione una opción'),
        rolCompra: yup.mixed().required('Seleccione una opción'),

        otraActividad: yup.string().test('validacion-otra-actividad', 'Especifique cual', function(value) {
          const actividadSelected = this.parent.actividadPrincipal;
          if(actividadSelected?.id === 'Otros (por favor, especifique)' && !value) {
              return false;
          }
          return true;
        }),

        otraArea: yup.string().test('validacion-otra-area', 'Especifique cual', function(value) {
          const areaDentroDeLaEmpresaSelected = this.parent.areaDentroDeLaEmpresa;
          if(areaDentroDeLaEmpresaSelected?.id === 'Otra (por favor, especifique)' && !value) {
              return false;
          }
          return true;
        }),

        otroCargo: yup.string().test('validacion-otro-cargo', 'Especifique cual', function(value) {
          const rolCargoSelected = this.parent.rolCargo;
          if(rolCargoSelected?.id === 'Otros' && !value) {
              return false;
          }
          return true;
        }),

      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + " error/es)", icon: "error"});
    },
    async validarDni() {
      try {
        if (this.formData.dni) {
          this.isSubmitting = true;
          let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.dni);
          if (acreditadoExistente) {
            Swal.fire({ title: "¡Atención!", html: "El DNI ya existe", icon: "warning" });
            return;
          }
        }
      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },      
    async onSubmit() {
      this.isSubmitting = true;

      try {
        if (this.formData.terminosCondiciones == false) {
          Swal.fire({ title: "¡Atención!", text: "Debe aceptar los términos y condiciones", icon: "error", allowOutsideClick: false });
          this.isSubmitting = false;
          return;
        }

        if (this.hash == '') {
          let buscado:Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.dni);
          if (buscado) {
            Swal.fire({ title: "¡Atención!", text: "El documento con el que se esta intentando registrar, ya se encuentra inscripto en el evento.", icon: "error", allowOutsideClick: false });
            this.isSubmitting = false;
            return;
          }

          buscado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "mail=" + encodeURIComponent(this.formData.mail));
          if (buscado) {
            Swal.fire({ title: "¡Atención!", text: "El mail con el que se esta intentando registrar, ya se encuentra inscripto en el evento.", icon: "error", allowOutsideClick: false });
            this.isSubmitting = false;
            return;
          }

          this.acreditado = new Object() as Acreditado;
          this.acreditado.tipoAcreditado = { "id": 2553 } as TipoAcreditado;
          this.acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
          this.acreditado.notificar = true;
          this.acreditado.modificado = SAVE;

          
        } else {
          let buscado:Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.dni);
          if (buscado && buscado.id != this.acreditado.id) {
            Swal.fire({ title: "¡Atención!", text: "Su DNI ya se encuentra registrado, verifique por favor el número ingresado o póngase en contacto con la organización<br/><br/>¡Muchas Gracias!", icon: "error", allowOutsideClick: false });
            this.isSubmitting = false;
            return;
          }

          this.acreditado.modificado = UPDATE;
          this.acreditado.notificar = true;
        }
    
        this.acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;

        this.acreditado.nombre = this.formData.nombre;
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.dni = this.formData.dni;
        this.acreditado.mail = this.formData.mail;
        this.acreditado.empresa = this.formData.empresa;
        this.acreditado.cargo = this.formData.cargo;
        this.acreditado.telefono = this.formData.pais.id + this.formData.codigoAreaCel + this.formData.telefonoCelular;

        this.acreditado.dato1 = this.formData.website;
        this.acreditado.dato2 = this.formData.pais.descripcion;
        if (this.formData.pais.id == '+54') {
          this.acreditado.dato3 = this.formData.provincia.descripcion;
        } else {
          this.acreditado.dato3 = this.formData.provinciaEstado;
        }
        this.acreditado.dato4 = this.formData.localidad;
        this.acreditado.dato5 = this.formData.instagram;
        this.acreditado.dato6 = this.formData.participo.id;
        this.acreditado.dato7 = this.formData.actividadPrincipal.id;
        this.acreditado.dato8 = this.formData.areaDentroDeLaEmpresa.id;
        this.acreditado.dato9 = this.formData.rolCargo.id;
        this.acreditado.dato10 = this.formData.rolCompra.id;

        if(this.formData.actividadPrincipal?.id === 'Otros') {
          this.acreditado.dato11 = this.formData.otraActividad;
        }
        if(this.formData.areaDentroDeLaEmpresa?.id === 'Otra') {
          this.acreditado.dato12 = this.formData.otraArea;
        }
        if(this.formData.rolCargo?.id === 'Otros') {
          this.acreditado.dato13 = this.formData.otroCargo;
        }

        this.acreditado.dato17 = this.formData.linkedin;
        this.acreditado.dato18 = this.formData.canalStreaming;

        const acreditados:Acreditado[] = [] as Acreditado[];
        acreditados.push(this.acreditado);

        const acreditadosActualizados: Acreditado[] = await suiteService.saveOrUpdateAll(suiteConfig.evento, acreditados);
        if (acreditadosActualizados.length > 0) {
          this.isSubmitting = false;

          var titulo = "Acreditación exitosa";
          var mensaje = "Recibimos tus datos correctamente<br/>ya estás inscripto en CAPER Show 2026<br/><br/>Te mandamos un email de confirmación.<br/><br/>Por favor chequear spam o correo no deseado"; 

          Swal.fire({
            title: titulo,
            html: mensaje,
            icon: "success",
          }).then(() => {
            this.$router.push({ path: '/final' });
            return;
          });
        }
      } catch(error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    }
  },
},
  async mounted() {
    this.paises = jsonPaises;
    this.provincias = jsonProvincias;
    this.opcionesSiNo = jsonSiNo;
    this.actividades = jsonActividades;
    this.areasEmpresa = jsonAreas;
    this.rolesCargo = jsonRolesCargo;
    this.rolesCompra = jsonRolesCompra;

    const route = useRoute();
    const hash = route.params.hash as string;

    if (hash != null) {
      this.hash = hash;
      this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
      if(!this.acreditado) {
        Swal.fire({ title: "Atención!!!", html: "El acreditado no existe.", icon: "error" }).then(() => {
          this.$router.push({ path: '/final' });
          return;
        });
        return;
      }

      if (this.acreditado.estadoAcreditado.id == VERIFICADO) {
        Swal.fire({ title: "¡Muchas gracias!", html: "Ya estás confirmado para participar del evento.", icon: "success" }).then(() => {
          this.$router.push({ path: '/final' });
          return;
        });
        return;
      }

      this.formData.nombre = this.acreditado.nombre;
      this.formData.apellido = this.acreditado.apellido;
      this.formData.dni = this.acreditado.dni;
      this.formData.mail = this.acreditado.mail;
      this.formData.mailConfirmacion = this.acreditado.mail;
      this.formData.empresa = this.acreditado.empresa;
      this.formData.cargo = this.acreditado.cargo;

      this.soloLectura = true;

    } else {
      this.soloLectura = false;
      this.hash = '';
    }
  }
});
</script>